import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ei-white">
        <Loader2 className="w-8 h-8 animate-spin text-ei-navy" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/staff/login" replace state={{ from: location.pathname }} />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/staff/dashboard" replace />;
  }
  return children;
}
